import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roles: null,
  loading: false,
  error: null,
};

const employerSlice = createSlice({
  name: 'employer',
  initialState,
  reducers: {
    setEmployerRoles(state, action) {
      state.roles = action.payload;
      state.loading = false;
      state.error = null;
    },
    setEmployerLoading(state, action) {
      state.loading = action.payload;
    },
    setEmployerError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    resetEmployer(state) {
      state.roles = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setEmployerRoles, setEmployerLoading, setEmployerError, resetEmployer } = employerSlice.actions;

export default employerSlice.reducer;
